export class DataCatalogPipeline {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "definition",
            "baseName": "definition",
            "type": "DataCatalogPipelineDefinition",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "DataCatalogPipelineState",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "DataCatalogPipelineSchedule",
            "format": ""
        },
        {
            "name": "boundVersion",
            "baseName": "boundVersion",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "pendingVersion",
            "baseName": "pendingVersion",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "createdBy",
            "baseName": "createdBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "agentSessionId",
            "baseName": "agentSessionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "viewDatasetId",
            "baseName": "viewDatasetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "parkedReason",
            "baseName": "parkedReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "parkedAt",
            "baseName": "parkedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "versionNote",
            "baseName": "versionNote",
            "type": "string",
            "format": ""
        },
        {
            "name": "versionAuthoredBy",
            "baseName": "versionAuthoredBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "versionAgentSessionId",
            "baseName": "versionAgentSessionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "versionChanges",
            "baseName": "versionChanges",
            "type": "Array<DataCatalogPipelineVersionChange>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipeline.attributeTypeMap;
    }
    constructor() {
    }
}
